import React from 'react'
import "./Googler.css"
// import img1 from "../../assets/r.png" 
import { Link } from 'react-router-dom'
import {HiLocationMarker} from "react-icons/hi"
import pdfLink from "../../assets/Googler.pdf"
const Googler = () => {
  return (
    <div className='google_container'>
    <div className="title">
        <h2>Googler</h2>            
    </div>
    <div className="evt_data">
        <div className="left">
            {/* <img src={img1} alt="" /> */}
        </div>
        <div className="right">
            <div className="r_detail">
            <p>Mar 14,2023</p>
            <h2>Googler</h2>
            </div>
            <div className="reg_data">
                <div className="flex-cont">
            <div className="evt_reg">
                <h2>Entry Fee : Rs. 50</h2>
                <div className="reg_btns">
                <Link to="https://docs.google.com/forms/d/e/1FAIpQLScTjIImXf7bdiSYx2c3oCm-5-siVHuBzT_E3R5N_9CjN-T73A/viewform?usp=sf_link" target="_blank" className="reg_btn">Register Now</Link>
                </div>
                </div>
            </div>
            <div className="desc">
                <h3>Description</h3>
                 <p>An event Googler is  where participants search questions on Google. However, it is common for people to use Google as a resource for finding answers to their questions or solving problems This could involve using search terms and phrases to find relevant information, utilizing Google's search filters and tools to refine results.</p>
                 <Link to={pdfLink} target="_blank" className="reg_btn">Rules & Regulations</Link>
            </div>
            <div className="date">
                <h3>Date & Time</h3>
                <div className="date_data">
                    <h4>Mar 14,2023</h4>
                </div>
            </div>
            <div className="loc">
                <h3>Location</h3>
                <p> <HiLocationMarker/>College of Engineering and Technology,Akola</p>
            </div>
            <div className="team">
                <h3><span>Coordinator</span> Team</h3>
                <div className="staf_team">
                    <h4>Staff Co-ordinator</h4>
                    <p>Prof Mangesh Shegokar  : +91 98225 68556</p>
                </div>
                <div className="team_data">
                    <h4>Student Co-ordinator</h4>
                    <p>Kanchan khambalkar  : +91 74107 82294</p>
                    <p>Nikita Fandi  : +91 8975279451</p>
                    <p>Amit Mankar : +91 83809 51247</p>
                    <p>Anuradha Gandhi : +91 8830774206</p>
                </div>
            </div>
            </div>
        </div>
    </div>
</div>
  )
}

export default Googler
